const updates = [
  { time: '10分钟前', title: '某知名导演新片选角引发粉丝大规模争论', tag: '影视' },
  { time: '28分钟前', title: '多地网友反映外卖平台价格异常，客服回应系统升级', tag: '民生' },
  { time: '1小时前', title: '国际体育赛事中国选手再夺金牌，评论区沸腾了', tag: '体育' },
  { time: '2小时前', title: '某科技公司新品发布会倒计时，吃瓜群众猜测功能亮点', tag: '科技' },
  { time: '3小时前', title: '热门游戏新版本更新日志曝光，玩家社区炸开锅', tag: '游戏' },
  { time: '5小时前', title: '食品安全抽检结果公布，多家知名餐饮品牌上榜', tag: '民生' },
  { time: '7小时前', title: '某女星在社交媒体发布神秘动态，粉丝疯狂解读', tag: '娱乐' },
  { time: '9小时前', title: '城市轨道交通新线路开通，沿线居民热议房价走势', tag: '社会' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          实时追踪全网热点，分秒必争为你呈现最新吃瓜资讯
        </p>
        <div className="max-w-3xl mx-auto relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300"></div>
          <div className="space-y-0">
            {updates.map((item, idx) => (
              <div key={idx} className="relative flex items-start gap-5 pb-6 last:pb-0">
                <div className="relative z-10 w-[38px] h-[38px] flex items-center justify-center flex-shrink-0">
                  <div className={`w-2.5 h-2.5 rounded-full ${
                    idx === 0 ? 'bg-primary-500 ring-4 ring-primary-100' :
                    idx === 1 ? 'bg-accent-500 ring-4 ring-accent-100' :
                    'bg-secondary-400 ring-4 ring-secondary-100'
                  }`}></div>
                </div>
                <div className="flex-1 min-w-0 pt-1.5">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed hover:text-primary-500 transition-colors cursor-pointer">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}